<script lang="ts" setup>
	const { name } = useRoute()
	const routeName = computed(() => String(name))
</script>

<template>
	<section>
		<header-sendcare-nav :variant="routeName" />
		<div class="md:mt-30">
			<nuxt-page />
		</div>
		<sendcare-footer :variant="routeName" />
	</section>
</template>
